import React from 'react'

function Text({ message }) {
  if (message === undefined) {
    // console.error('message is undefined', message);
    return <div><span>Error 2 In Message Computing Please Contact Admin"</span></div>
  } else {
    // console.log('message is defined', message);
    // console.error();
    if (message === "...") {
        return (
            <div>
                <span className="dot"></span>
                <span className="dot"></span>
                <span className="dot"></span>
            </div>
        )
    }
    else {
        return (
            <div>
                {message
                    .split('\n')
                    .join("<br>")
                    .split("<br>")
                    .map((item, key) => <span key={key}>{item}<br /></span>)}
            </div>
        )
    }
  }
}

export default Text



// WEBPACK FOOTER //
// ./src/views/components/Message.js